export const siteKeys = {
  all: ['sites'] as const,
  checkCode: (code: string): readonly unknown[] => [...siteKeys.all, 'check-code', code] as const,
  detail: (id: string): readonly unknown[] => [...siteKeys.all, 'detail', id] as const,
  search: (params?: Record<string, unknown>): readonly unknown[] => [...siteKeys.all, 'search', params] as const,
};
